<template>
    <v-container
            id="order-items"
            fluid
            tag="section"
    >
        <v-data-table
                :options.sync="options"
                :loading="loading"
                :loading-text="$t('global.loading')"
                :items="shipmentsItems"
                :server-items-length="totalItems"
                :headers="headers"
                :footer-props="footerProps"
                :no-data-text="$t('global.no_data')"
        >

            <template v-slot:item.id="{ item }">
                #{{item.id.substring(0, 8)}}
            </template>

            <template v-slot:item.products_title="{ item }">
                <div v-for="product in item.products"
                     :key="product.id">
                    <ProductListDetail v-bind:product="product"></ProductListDetail>
                </div>
            </template>

            <template v-slot:item.status="{ item }">
                <ShipmentListDetail  v-bind:shipment="item" @onShipmentUpdated="onShipmentUpdated"></ShipmentListDetail>
            </template>

            <template v-slot:item.order="{ item }">
                {{item.reference}}
            </template>
            <template v-slot:item.created_datetime="{ item }">
                {{item.created_datetime | momentDate}}
            </template>
            <template v-slot:item.sent_datetime="{ item }">
                {{item.sent_datetime | momentDate}}
            </template>
            <template v-slot:item.delivered_datetime="{ item }">
                {{item.delivered_datetime | momentDate}}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import {createQueryString} from "../../../helpers/createQueryString";
    import mappingStatusColors from '../../../config/mapping-status-colors'
    import {mapGetters} from "vuex";
    import ProductListDetail from "../../components/ProductListDetail";
    import ShipmentListDetail from "../../components/ShipmentListDetail";

    export default {
        name: 'Shipments.List',
        components: {
            ProductListDetail, ShipmentListDetail
        },
        data() {
            return {
                snackbar: false,
                color: 'info',
                message: '',
                loading: false,
                headers: [
                    {text: this.$i18n.t('shipments.headers.products'), value: 'products_title', sortable: false},
                    {text: this.$i18n.t('shipments.headers.carrier'), value: 'carrier', sortable: false, align: 'center'},
                    {text: this.$i18n.t('shipments.headers.status'), value: 'status', sortable: false, align: 'center'},
                    {text: this.$i18n.t('shipments.headers.ref'), value: 'order', sortable: false, align: 'center'},

                    {text: this.$i18n.t('shipments.headers.created_datetime'), value: 'created_datetime', sortable: false, align: 'center'},
                    {text: this.$i18n.t('shipments.headers.sent_datetime'), value: 'sent_datetime', sortable: false, align: 'center'},
                    {text: this.$i18n.t('shipments.headers.delivered_datetime'), value: 'delivered_datetime', sortable: false, align: 'center'},
                    {text: '', value: 'menu', sortable: false,align: 'center'},
                ],
                footerProps: {'items-per-page-options': [30], 'show-first-last-page': true},
                options: {
                    page: 1,
                    itemsPerPage: 30,
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false,
                    sortBy: ['status'],
                    sortDesc: [false],

        },
                shipmentsItems: [],
                totalItems: 0
            };
        },
        methods: {
            onShipmentUpdated() {
                this.load();
            },
            load() {
                this.loading = true;
                this.shipmentsItems = [];
                let params = {page: this.options.page, ...this.$route.params, ...this.$route.query, ...this.filters, order: {}};

                // Define sorting parameters.
                if (this.options.sortBy.length) {
                    params.order[this.options.sortBy[0]] = this.options.sortDesc[0] ? 'desc' : 'asc';
                }

                this.$axios.get('shipments?' +  createQueryString(params))
                    .then(response => {
                        this.loading = false;
                        this.shipmentsItems = response.data['hydra:member'];
                        this.totalItems = response.data['hydra:totalItems'];
                    });
            },
            getStatusLabel(status) {
                return this.$i18n.t('shipments.status_labels.' + status.toLowerCase())
            },
            getStatusColor(status) {
                return mappingStatusColors[status];
            },

        },
        watch: {
            queryString: {
                handler() {
                    this.load();
                }
            }
        },
        computed: {
            ...mapGetters(['isAdmin']),
            queryString: function () {
                let params = {page: this.options.page, ...this.$route.params, ...this.$route.query, ...this.filters, order: {}};
                return createQueryString(params);
            },
        },
        mounted() {
            this.load();

            if (this.isAdmin) {
                this.headers.unshift(
                    {text: this.$i18n.t('shipments.id'), value: 'id', sortable: false},
                );
            }
        }
    }
</script>
